<template>
  <section class="featuredImage">
    <FlarePicture
      class="featuredImage__Image"
      :src="{
        1920: { src: data.image, width: 1920, height: 930, size: 'both', crop: 'fill', requestLarger: false },
        1440: { src: data.image, width: 1440, height: 700, size: 'both', crop: 'fill', requestLarger: false },
        1024: { src: data.image, width: 1100, height: 535, size: 'both', crop: 'fill', requestLarger: false },
        768: { src: data.image_mobile || data.image, width: 800, height: 1240, size: 'both', crop: 'fill', requestLarger: false },
      }"
      :alt="data.image?.alt"
    />
    <div class="container featuredImage__Content">
      <p v-text="data.description" />
    </div>
  </section>
</template>

<script setup>
  defineProps({
    data: {},
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_featuredImage.scss');
</style>